const static_market_page = {
    gold: {
        title: 'نرخ طلا',
        items: [
            'geram18', 'geram24', 'gold_740k', 'gold_mini_size'
        ]
    },
    currency: {
        title: "نرخ ارز",
        items: [
            'bank_usd', 'price_afn', 'price_iqd', 'price_sek', 'price_dollar_rl',
        ]
    }
};

export default static_market_page;